omadapp.controllers.scenes.quizz_question = function($page,data) {
	var t = this
	var $ = jQuery
	t.data = data
	t.$page =$page
	t.initialize = initialize

	var $js_continue = $page.find(".js_continue")
	var $js_question = $page.find(".js_question")
	var $js_answers = $page.find(".js_answers")
	var $js_image = $page.find(".js_image")

	function initialize () {
		t.super.initialize.call(t)
		trace ("initialize")
		trace ($page[0])
		t.question = new omadapp.components.Question($js_question, data)
		$js_question.on("question-answered",questionAnswered)
	}

	function questionAnswered(e,answer) {
		
		$js_continue.removeClass("hidden")
		t.mainPage.setScore(t.nid,answer.score)
		$js_continue.off("click").click(function(e) {
			e.preventDefault()
			$page.trigger("linearNav.next",t)
		})
	}

	
}